import { candidate as candidateService, race as raceService } from '../../services';

export const ActionTypes = {
  SET_CANDIDATES: 'SET_CANDIDATES',
  SET_ALL_APPROVED_CANDIDATES: 'SET_ALL_APPROVED_CANDIDATES',
  SET_ALL_UNAPPROVED_CANDIDATES: 'SET_ALL_UNAPPROVED_CANDIDATES',
  CLEAR_CANDIDATES: 'CLEAR_CANDIDATES',
  SET_SELECTED_CANDIDATE: 'SET_SELECTED_CANDIDATE',
  SET_SELECTED_CANDIDATE_OBJ: 'SET_SELECTED_CANDIDATE_OBJ',
  CLEAR_SELECTED_CANDIDATE: 'CLEAR_SELECTED_CANDIDATE',
  API_ERROR: 'API_ERROR',
};

/**
 * @description action creator for selecting a candidate
 * @param {String} electionId the id of the candidate to select
 */
export const setSelectedCandidate = (candidateId) => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.SET_SELECTED_CANDIDATE, payload: candidateId });
  };
};

/**
 * @description action creator for clearing selected candidate
 */
export const clearSelectedCandidate = () => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CLEAR_SELECTED_CANDIDATE });
  };
};

/**
 * @description action creator for creating a candidate
 * @param {Object} fields fields about candidate to create
 * @param {String} raceId id of race to attach candidate to
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const createCandidate = (fields, raceId, successCallback = () => {}, failureCallback = () => {}) => {
  return async (dispatch) => {
    try {
      const result = await candidateService.createCandidate(fields);
      await raceService.addCandidateToRace(raceId, result[0]._id);

      successCallback();
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: 'CREATE_CANDIDATE',
          error,
        },
      });

      failureCallback(error);
    }
  };
};

/**
 * @description action creator for creating a candidate
 * @param {Object} fields fields about candidate to create
 * @param {String} raceId id of race to attach candidate to
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const fetchCandidate = (candidateId) => {
  return async (dispatch) => {
    try {
      const result = await candidateService.fetchCandidateById(candidateId);
      dispatch({ type: ActionTypes.SET_SELECTED_CANDIDATE_OBJ, payload: result });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: 'SET_SELECTED_CANDIDATE_OBJ',
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for getting all unapproved candidates
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const getAllUnapprovedCandidates = (successCallback = () => {}, failureCallback = () => {}) => {
  return async (dispatch) => {
    try {
      const candidates = await candidateService.fetchAllUnapprovedCandidates();
      dispatch({ type: ActionTypes.SET_ALL_UNAPPROVED_CANDIDATES, payload: candidates });
      successCallback();
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_ALL_UNAPPROVED_CANDIDATES,
          error,
        },
      });

      failureCallback(error);
    }
  };
};

/**
 * @description action creator for getting all approved candidates
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const getAllApprovedCandidates = (successCallback = () => {}, failureCallback = () => {}) => {
  return async (dispatch) => {
    try {
      const candidates = await candidateService.fetchAllApprovedCandidates();
      dispatch({ type: ActionTypes.SET_ALL_APPROVED_CANDIDATES, payload: candidates });
      successCallback();
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_ALL_APPROVED_CANDIDATES,
          error,
        },
      });

      failureCallback(error);
    }
  };
};

/**
 * @description action creator for admin approving a candidate
 * @param {String} raceId id of race
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const adminApproveCandidate = (candidateId, successCallback = () => {}, failureCallback = () => {}) => {
  return async (dispatch) => {
    try {
      await candidateService.adminApproveCandidate(candidateId);

      const unApprovedCandidates = await candidateService.fetchAllUnapprovedCandidates();
      dispatch({ type: ActionTypes.SET_ALL_UNAPPROVED_CANDIDATES, payload: unApprovedCandidates });

      const approvedCandidates = await candidateService.fetchAllApprovedCandidates();
      dispatch({ type: ActionTypes.SET_ALL_APPROVED_CANDIDATES, payload: approvedCandidates });

      successCallback();
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_ALL_UNAPPROVED_CANDIDATES,
          error,
        },
      });

      failureCallback(error);
    }
  };
};

/**
 * @description action creator for admin unapproving a candidate
 * @param {String} raceId id of race
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const adminUnapproveCandidate = (candidateId, successCallback = () => {}, failureCallback = () => {}) => {
  return async (dispatch) => {
    try {
      await candidateService.adminUnapproveCandidate(candidateId);

      const unApprovedCandidates = await candidateService.fetchAllUnapprovedCandidates();
      dispatch({ type: ActionTypes.SET_ALL_UNAPPROVED_CANDIDATES, payload: unApprovedCandidates });

      const approvedCandidates = await candidateService.fetchAllApprovedCandidates();
      dispatch({ type: ActionTypes.SET_ALL_APPROVED_CANDIDATES, payload: approvedCandidates });

      successCallback();
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_ALL_UNAPPROVED_CANDIDATES,
          error,
        },
      });

      failureCallback(error);
    }
  };
};
